import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetMobileServiceCountRowsQueryVariables = Types.Exact<{
  scope: Types.Mobility_Runs_Bool_Exp;
  window: Types.Mobility_Runs_Bool_Exp;
}>;


export type GetMobileServiceCountRowsQuery = { __typename?: 'query_root', upcoming: Array<{ __typename?: 'mobility_runs', id: number, customer_id: number }>, active: Array<{ __typename?: 'mobility_runs', id: number, customer_id: number }>, completed: Array<{ __typename?: 'mobility_runs', id: number, customer_id: number }>, cancelled: Array<{ __typename?: 'mobility_runs', id: number, customer_id: number }> };


export const GetMobileServiceCountRowsDocument = gql`
    query getMobileServiceCountRows($scope: mobility_runs_bool_exp!, $window: mobility_runs_bool_exp!) {
  upcoming: mobility_runs(
    where: {product_type: {_eq: "mobile_service"}, _and: [$scope, $window, {status: {_in: ["draft", "scheduled", "dispatched", "claimed"]}}]}
  ) {
    id
    customer_id
  }
  active: mobility_runs(
    where: {product_type: {_eq: "mobile_service"}, _and: [$scope, $window, {status: {_in: ["in_transit"]}}]}
  ) {
    id
    customer_id
  }
  completed: mobility_runs(
    where: {product_type: {_eq: "mobile_service"}, _and: [$scope, $window, {status: {_in: ["completed"]}}]}
  ) {
    id
    customer_id
  }
  cancelled: mobility_runs(
    where: {product_type: {_eq: "mobile_service"}, _and: [$scope, $window, {status: {_in: ["cancelled", "canceled"]}}]}
  ) {
    id
    customer_id
  }
}
    `;

/**
 * __useGetMobileServiceCountRowsQuery__
 *
 * To run a query within a React component, call `useGetMobileServiceCountRowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMobileServiceCountRowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMobileServiceCountRowsQuery({
 *   variables: {
 *      scope: // value for 'scope'
 *      window: // value for 'window'
 *   },
 * });
 */
export function useGetMobileServiceCountRowsQuery(baseOptions: Apollo.QueryHookOptions<GetMobileServiceCountRowsQuery, GetMobileServiceCountRowsQueryVariables> & ({ variables: GetMobileServiceCountRowsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMobileServiceCountRowsQuery, GetMobileServiceCountRowsQueryVariables>(GetMobileServiceCountRowsDocument, options);
      }
export function useGetMobileServiceCountRowsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMobileServiceCountRowsQuery, GetMobileServiceCountRowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMobileServiceCountRowsQuery, GetMobileServiceCountRowsQueryVariables>(GetMobileServiceCountRowsDocument, options);
        }
// @ts-ignore
export function useGetMobileServiceCountRowsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMobileServiceCountRowsQuery, GetMobileServiceCountRowsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMobileServiceCountRowsQuery, GetMobileServiceCountRowsQueryVariables>;
export function useGetMobileServiceCountRowsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMobileServiceCountRowsQuery, GetMobileServiceCountRowsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMobileServiceCountRowsQuery | undefined, GetMobileServiceCountRowsQueryVariables>;
export function useGetMobileServiceCountRowsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMobileServiceCountRowsQuery, GetMobileServiceCountRowsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMobileServiceCountRowsQuery, GetMobileServiceCountRowsQueryVariables>(GetMobileServiceCountRowsDocument, options);
        }
export type GetMobileServiceCountRowsQueryHookResult = ReturnType<typeof useGetMobileServiceCountRowsQuery>;
export type GetMobileServiceCountRowsLazyQueryHookResult = ReturnType<typeof useGetMobileServiceCountRowsLazyQuery>;
export type GetMobileServiceCountRowsSuspenseQueryHookResult = ReturnType<typeof useGetMobileServiceCountRowsSuspenseQuery>;
export type GetMobileServiceCountRowsQueryResult = Apollo.QueryResult<GetMobileServiceCountRowsQuery, GetMobileServiceCountRowsQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * Multiple root fields (upcoming, active, completed, cancelled): returns the full response object.
 * @source {@link src/features/mobileService/counts/getMobileServiceCountRows.query.gql}
 */
export async function getMobileServiceCountRows(
  variables: GetMobileServiceCountRowsQueryVariables,
  options?: { executor?: GqlExecutor } & GqlRequestOptions
): Promise<GetMobileServiceCountRowsQuery> {
  const { executor, ...requestOptions } = options ?? {}
  return resolveExecutor(executor).query<GetMobileServiceCountRowsQuery>(
    GetMobileServiceCountRowsDocument,
    variables,
    requestOptions
  )
}